<template>
  <div class="amount">
    <div class="number-wheel">
      <span v-for="(number, index) in [1, 2, 3, 4, 5]" :key="index">
        {{ number }}
      </span>
    </div>
    <span class="number">0</span>
    <span class="number">0</span>
    <span class="number">0</span>
    <span class="number">0</span>
    <span class="number">0</span>
    <span class="number">0</span>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

@keyframes roll {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-428px);
  }
}
.amount {
  padding: 0 135px;
  height: 107px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  .number-wheel {
    font-size: 76px;
    font-family: DIN-Medium, DIN;
    font-weight: 500;
    color: #560505;
    line-height: 107px;
    height: 107px;
    overflow: hidden;
    background: url("../images/act2_img_kuang@2x.png") no-repeat;
    background-size: 100%;
    text-align: center;
    span {
      width: 63px;
      height: 107px;
      display: block;
      animation: roll 1s forwards;
      position: relative;
    }
  }
  .number {
    width: 63px;
    height: 107px;
    font-size: 76px;
    font-family: DIN-Medium, DIN;
    font-weight: 500;
    color: #560505;
    line-height: 107px;
    background: url("../images/act2_img_kuang@2x.png") no-repeat;
    background-size: 100%;
    text-align: center;
  }
}
</style>
